import { render, staticRenderFns } from "./StepViewEnvCollect.vue?vue&type=template&id=1dac4f26"
import script from "./StepViewEnvCollect.vue?vue&type=script&lang=js"
export * from "./StepViewEnvCollect.vue?vue&type=script&lang=js"
import style0 from "./StepViewEnvCollect.vue?vue&type=style&index=0&id=1dac4f26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports